export default "__VITE_ASSET__CRdebWOh__"